export default {"src":"/_next/static/media/youtube-icon-30-20.afc9e247.svg","height":21,"width":31};